import { MenuDiscount } from '../../../../../../shared/models/food-menu';
import {
	RBHBox,
	RBHButton,
	RBHDatePicker,
	RBHSelect,
	RBHText,
	RBHTextInput,
} from '../../../../../../shared/components';
import styleButton from '../../../../../../shared/components/rbh-button/styles';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import textStyles from '../../../../../../shared/components/rbh-text/styles';
import styles from '../styles';
import { Checkbox, Col, Form,  Row, Select } from 'antd';
import { UtilHelper } from '../../../../../../shared/helpers/utility';
import type { FormInstance } from 'antd/es/form';
import { MENU_PRICE_REGEX } from '../../../redux/foodmenu-constant';
import { FormattedMessage } from 'react-intl';
import { useMenuDiscount } from './useMenuDiscount';
import { Moment } from 'moment';
import { useDispatch } from 'react-redux';
import { generalCreators } from '../../../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../../../redux/general/general-constant';


const { Option } = Select;
export const MenuDiscountComponent = (props: {
	shouldEnable: boolean;
	deleteDiscountSwitch?: boolean;
	open: boolean;
	onOpenChange: (open: boolean) => void
	menuDiscounts?: MenuDiscount[];
	normalPrice: number;
	form: FormInstance;
	handleDeletedMenu: (id: number) => void
}) => {
	const form = props.form;
	const menuDiscount = Array.isArray(props.menuDiscounts) && props.menuDiscounts.length ? props.menuDiscounts[0] : undefined
	const {
		discountedPrice,
		isDiscountedPriceChange,
		startDate,
		startTime,
		endDate,
		endTime,
		startTimeList,
		endTimeList,
		validateDiscountedPrice,
		updateDiscountedPrice,
		updateStartPromotionDate,
		updateStartPromotionTime,
		updateEndPromotionDate,
		updateEndPromotionTime,
		setInitialValues,
		displayStartTimeOption,
		shouldDisableStartDate,
		shouldDisableEndDate,
		displayEndTimeOption,
		resetFields
	} = useMenuDiscount();
	const [isShowEndDate, setIsShowEndDate] = useState(
		Boolean(menuDiscount?.endDate)
	);
	const dispatch = useDispatch();
	const normalPrice = useMemo(() => UtilHelper.removeComma(String(props.normalPrice)), [props.normalPrice])
	const isCampaignStatusActive = useMemo(() => menuDiscount?.menuDiscountStatus === 'ACTIVE', [menuDiscount?.menuDiscountStatus])
	const discountPercent = useMemo(() => {
		const discountPriceNumber = Number(UtilHelper.removeComma(discountedPrice))
		if (isDiscountedPriceChange) {
			const discountPercentNumber = !isNaN(Number(discountPriceNumber)) ? Math.floor(((normalPrice - discountPriceNumber) / normalPrice) * 100): 0
			if (isNaN(discountPercentNumber) || !isFinite(discountPercentNumber) || discountPercentNumber < 0) {
				return '0'
			} else if (discountPercentNumber > 100) {
				return '100'
			}
			return String(discountPercentNumber)
		}
	}, [discountedPrice, normalPrice])

	const deleteDiscountItem = () => {
		if (menuDiscount) {
			props.handleDeletedMenu(menuDiscount.menuDiscountId)
		}
		resetFields();
		form.resetFields();
		setIsShowEndDate(false);
	}

	useEffect(() => {
		form.validateFields();
	}, [normalPrice]);

	useEffect(() => {
		if (props.deleteDiscountSwitch === undefined) {
			return;
		}
		deleteDiscountItem();
	}, [props.deleteDiscountSwitch])

	useEffect(() => {
		if (!menuDiscount) return;
		const values = setInitialValues(menuDiscount);
		setIsShowEndDate(values.isEnableEndDate)
		form.setFieldsValue({
			startPromotionDate: values.startDateTime.startDate,
			startPromotionTime: values.startDateTime.startTime,
			endPromotionDate: values.endDateTime.endDate,
			endPromotionTime: values.endDateTime.endTime,
			discountedAmount: values.priceDiscount,
			isEnableEndDate: values.isEnableEndDate,
		})
	}, [menuDiscount])

	if (!props.shouldEnable) {
		return <></>
	}
	if (!props.open) {
		return <AddDiscountButton onClick={() => props.onOpenChange(true)} />;
	}

	const handleDeleteDiscount = () => {
		if (menuDiscount) {
			dispatch(
				generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL,
					{
						visible: true,
						type: MODAL_TYPE.DELETE_DISCOUNT,
						onOk: () => {
							deleteDiscountItem();
							dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
								visible: false,
							}))
						},
						onCancel: () => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
								visible: false,
							}))
					}
			))
			return
		}
		props.onOpenChange(false)
	}

	const resetStartPromotionDateTimeError = () => {
		form.setFields([
			{ name: 'startPromotionDate', errors: []},
			{ name: 'startPromotionTime', errors: []}
		])
	}
	const resetEndPromotionDateTimeError = () => {
		form.setFields([
			{ name: 'endPromotionDate', errors: []},
			{ name: 'endPromotionTime', errors: []}
		])
	}

	return (
		<RBHBox style={styles.discountBox}>
			<Form form={form} name='discount-section' autoComplete='off' layout='vertical'>
				<Row style={{width: '100%', justifyContent: 'space-between'}}>
					<RBHBox>
						<RBHText style={textStyles.textRegular20} text={<FormattedMessage id={'main.foodmenu.addmenu.form.discount.title'} />} />
						<RBHText style={{color: '#828282'}} text={<FormattedMessage id={'main.foodmenu.addmenu.form.discount.description'} />} />
					</RBHBox>
					<RBHBox style={{cursor: 'pointer'}} onClick={handleDeleteDiscount}>
						<DeleteOutlined style={{color: '#FF2D2D'}} translate={null} />
					</RBHBox>
				</Row>
				<Row style={{paddingTop: 16}} justify='space-between'>
					<Col span={12}>
						<Form.Item
							style={{paddingRight: 12}}
							name='discountedAmount'
							initialValue={''}
							rules={[
								{
									validator: () => validateDiscountedPrice(normalPrice)
								},
								{
									pattern: MENU_PRICE_REGEX,
									message: <FormattedMessage id={'main.foodmenu.addmenu.prices.validate'} />
								}
							]}
							validateTrigger={['onBlur']}
						>
							<RBHTextInput variant='outlined' id='discount'
								label={<FormattedMessage id={'main.foodmenu.addmenu.form.discount.priceDiscount.label'} />}
								style={{width: '100%'}}
								value={discountedPrice}
								disabled={isCampaignStatusActive}
								onChange={(event: ChangeEvent<HTMLInputElement>) => updateDiscountedPrice(event.target.value)}
								onBlur={() => {
									const value = form.getFieldValue('discountedAmount');
									form.setFieldsValue({
									  discountedAmount: UtilHelper.currencyFormat(value)
									});
									updateDiscountedPrice(value)
									form.validateFields()
								  }}
								onFocus={() => {
									const value = form.getFieldValue('discountedAmount');
									form.setFieldsValue({
									  discountedAmount: UtilHelper.removeComma(value)
									});
								  }}
								required />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item style={{paddingLeft: 12}}>
							<RBHTextInput
								variant='outlined'
								label={<FormattedMessage id={'main.foodmenu.addmenu.form.discount.discountPercent.label'} />}
								value={discountPercent} 
								disabled
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<RBHText
						style={{fontSize: 16, fontWeight: 400, paddingBottom: 8}}
						text={<FormattedMessage id='main.foodmenu.addmenu.form.discount.startDateTime.label'  />}
					/>
				</Row>
				<Row justify='space-between'>
					<Col span={12}>
						<Form.Item
							initialValue={null}
							name='startPromotionDate'
							style={{paddingRight: 12}}
						>
							<RBHDatePicker
								variant='outlined'
								disabled={isCampaignStatusActive}
								label={<FormattedMessage id='main.foodmenu.addmenu.form.discount.startDate.label'/>}
								style={{width: '100%', height: 40}}
								value={startDate}
								disabledDate={shouldDisableStartDate}
								onChange={(value: Moment) => {
									const errorFields = updateStartPromotionDate(value);
									form.setFields([{name: 'startPromotionDate', errors: []}])
									if (errorFields) {
										form.setFields(errorFields)
									} else {
										resetStartPromotionDateTimeError()
										form.setFields([
											{name: 'startPromotionDate', errors: []},
										])
									}
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item name='startPromotionTime' initialValue={''}  style={{paddingLeft: 12}}>
							<RBHSelect
								variant='outlined'
								disabled={isCampaignStatusActive}
								label={<FormattedMessage id='main.foodmenu.addmenu.form.discount.startTime.label'/>}
								value={startTime}
								onChange={(value: string) => {
									const errorFields = updateStartPromotionTime(value)
									if (errorFields) {
										form.setFields(errorFields)
									} else {
										resetStartPromotionDateTimeError()
									}
								}}
								onDropdownVisibleChange={displayStartTimeOption}
								style={{width: '100%'}}
							>
								{startTimeList.map((item) => (
									<Option
										disabled={item.disabled}
										value={item.value}
									>
										{item.value}
									</Option>
								))}
							</RBHSelect>
						</Form.Item>
					</Col>
				</Row>
				<Form.Item initialValue={false} name='isEnableEndDate' valuePropName='checked' style={{marginBottom: 8}}>
					<Row>
						<Checkbox
							value={isShowEndDate}
							checked={isShowEndDate}
							onChange={(value) => setIsShowEndDate(value.target.checked)}
						/>
						<RBHText style={{paddingLeft: 6}} text={<FormattedMessage id='main.foodmenu.addmenu.form.discount.enablePromotionEndDateTime.label' />}/>
					</Row>
				</Form.Item>
				{isShowEndDate && (
					<Row justify='space-between' >
						<Col span={12}>
							<Form.Item name='endPromotionDate' initialValue={null} style={{paddingRight: 12}}>
								<RBHDatePicker 
								variant='outlined'
								value={endDate}
								type='text'
								label={<FormattedMessage id='main.foodmenu.addmenu.form.discount.endDate.label'/>}
								onChange={(input: Moment) => {
									const errorFields = updateEndPromotionDate(input)
									if (errorFields) {
										form.setFields(errorFields)
									} else {
										resetEndPromotionDateTimeError()
									}
								}}
								disabledDate={shouldDisableEndDate}
								style={{width: '100%', height: 40}}
								 />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name='endPromotionTime' initialValue={''}  style={{paddingLeft: 12}}>
								<RBHSelect
									variant='outlined'
									label={<FormattedMessage id='main.foodmenu.addmenu.form.discount.endTime.label'/>}
									onChange={(value: string) => {
										updateEndPromotionTime(value);
										resetEndPromotionDateTimeError();
									}}
									onDropdownVisibleChange={displayEndTimeOption}
									value={endTime}
									style={{width: '100%'}}
								>
									{endTimeList.map((item) => (
										<Option disabled={item.disabled} value={item.value}>{item.value}</Option>
									))}
								</RBHSelect>
							</Form.Item>
						</Col>
					</Row>
				)}
			</Form>
		</RBHBox>
	);
};

const AddDiscountButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<RBHButton style={styleButton.buttonAddMenuDiscount} onClick={onClick}>
			<>
				<RBHBox style={styles.inlineBlock}>
					<PlusOutlined style={styles.iconPlus} translate={null} />
				</RBHBox>
				<RBHBox style={styles.inlineBlock}>
					<RBHText
						style={textStyles.textDarkOrchid}
						text='main.foodmenu.addmenu.button.title.addDiscount'
					/>
				</RBHBox>
			</>
		</RBHButton>
	);
};
